import {ToggleScroll} from "./toggle-scroll";

class CloseModal {
    documentEl = document.body

    constructor(el) {
        this.el = el;
        this.overlay = this.el.querySelector(".js-overlay");
        this.closeBtns = this.el.querySelectorAll(".js-modal-close");

        this.listenEvents();
    }

    listenEvents() {
        this.overlay.addEventListener("click", this.close);
        this.closeBtns.forEach(btn => btn.addEventListener("click", this.close));
    }

    close = () => {
        this.el.classList.remove("shown");
        ToggleScroll.enable(this.el);
    };
}

window.addEventListener(
    "load",
    document
        .querySelectorAll(".js-modal")
        .forEach(modal => new CloseModal(modal))
);
